export const Header = (function () {
  "use strict";

  let $menu,
    $menuButton,
    $subMenuParent,
    $subMenuItem,
    $body,
    $header,
    $window,
    lastScroll;

  function init() {
    ($menu = $(".site-header__nav .nav-items")),
      ($menuButton = $(".mobile-menu-button"));
    $body = $("body");
    $subMenuParent = $("#menu-main-menu > .menu-item-has-children");
    $subMenuItem = $(".site-header .sub-menu a");
    $header = $(".site-header");
    $window = $(window);
    lastScroll = 0;

    events();
  }

  function events() {
    $window.on("load", updateBodyPadding);
    // updateBodyPadding();
    $window.on("resize", updateBodyPadding);

    $menuButton.click(function () {
      if ($menu.hasClass("open")) {
        $body.removeClass("mobile-menu-open");
        $menu.removeClass("open");
        $menuButton.removeClass("open");
        $menuButton.find("span").text("MENU");
      } else {
        $body.addClass("mobile-menu-open");
        $menu.addClass("open");
        $menuButton.addClass("open");
        $menuButton.find("span").text("CLOSE");
        
      }
    });

    let subMenuCount = 1;

    $subMenuParent.each(function () {
      const $this = $(this);
      const id = `#submenu-${subMenuCount++}`;
      const subMenuTitle = $this.find("> a").text();
      var $subMenuToggle = $(
        `<button class="sub-menu-toggle" aria-label="sub menu toggle for ${subMenuTitle}" aria-controls="${id}" aria-expanded="false">Toggle Menu</button>`
      );
      $this.find("> a").after($subMenuToggle);
      $this.find("> ul").attr("id", id);
    });

    var openMenu = function ($el) {
      $subMenuParent.removeClass("menu--open");
      $subMenuParent.find(".sub-menu-toggle").attr("aria-expanded", "false");
      $el.addClass("menu--open");
      $el.find(".sub-menu-toggle").attr("aria-expanded", "true");
    };

    var closeMenu = function ($el) {
      $el.removeClass("menu--open");
      $el.find(".sub-menu-toggle").attr("aria-expanded", "false");
    };

    $subMenuParent.on("click", ".sub-menu-toggle", function (e) {
      e.preventDefault();
      var $parent = $(this).parent();
      if ($parent.hasClass("menu--open")) {
        closeMenu($parent);
      } else {
        openMenu($parent);
      }
    });

    $subMenuParent.on("mouseenter", function (e) {
      // console.log('mouseover', e.target, this)
      e.stopPropagation();
      if (e.target == this) {
        var $this = $(this);
        if (!$this.hasClass("menu--open")) {
          openMenu($this);
        }
      }
    });

    $subMenuParent.on("mouseleave", function (e) {
      // console.log('mouseout', e.target, this)
      closeMenu($(this));
    });

    function areaExpanded() {
      if ($(".search--open").length) {
        $("li.icon--search a").attr("aria-expanded", "true");
      } else {
        $("li.icon--search a").attr("aria-expanded", "false");
      }
    }

    $("body").click(function (evt) {
      if (
        $body.hasClass("search--open") &&
        $(evt.target).closest(".container--search").length < 1 &&
        $(evt.target).closest("li.icon--search").length < 1
      ) {
        $body.removeClass("search--open");
        areaExpanded();
      }
    });

    $("li.icon--search a").click(function (e) {
      e.preventDefault();
      if ($body.hasClass("search--open")) {
        $body.removeClass("search--open");
      } else {
        $body.addClass("search--open");
        $('.site-header .container--search input[type="search"]').focus();
      }

      areaExpanded();
    });


    if ($(".search-form input.search-field").val() == "") {
      $(".search-form .btn").prop('disabled', true);
    } 

    $("input.search-field").on("keyup", function () {
      var $t = $(this);
      if ($t.val() !== "") {
        $(".search-form .btn").addClass("btn--active").removeAttr('disabled');
      } else {
        $(".search-form .btn").removeClass("btn--active").prop('disabled', true);
      }
    });

    $(".search-form").on("submit", function (e) {
      if ($(this).find("input.search-field").val() == "") {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    document.onkeydown = function (evt) {
      evt = evt || window.event;
      if (evt.keyCode == 27) {
        if ($body.hasClass("search--open")) {
          $body.removeClass("search--open");
        }
      }
    };

    // check on load
    $window.trigger("hashchange");

    $window.on("scroll", function () {
      var top = $window.scrollTop();

      if (top > $header.height()) {
        $body.addClass("scrolled");
        $(".site-header:not(.impact-header)").removeClass("bg--blue");
      } else {
        $body.removeClass("scrolled");
        if ($("body").hasClass("home")) {
          $(".site-header:not(.impact-header)").addClass("bg--blue");
        }
      }  

      // any value < header height show
      if (top < $header.height()) {
        $body.removeClass("hide-header");
        return;
      }

      // any scroll down - hide
      if (top > lastScroll) {
        $body.addClass("hide-header");

        // any scroll up - show
      } else {
        $body.removeClass("hide-header");
      }

      lastScroll = top;
    });

    /* Resources URL Current */
    const currentURL = window.location.pathname;

    $(".blog-category-nav a").each(function () {
      const href = $(this).attr("href");
    
      if (href === currentURL) {
        $(this).addClass("current");
      } else if (
        (href.includes("/resources/") || href.includes("/resource-hub/")) &&
        (currentURL.startsWith("/resources/") || currentURL.startsWith("/resource-hub/")) &&
        href !== "/resources/" &&
        href !== "/resource-hub/"
      ) {
        const subPath = currentURL.split("/resources/")[1] || currentURL.split("/resource-hub/")[1];
        if (
          subPath && 
          (subPath.startsWith(href.split("/resources/")[1]) || subPath.startsWith(href.split("/resource-hub/")[1]))
        ) {
          $(this).addClass("current");
        }
      }
    });
    

    function updateBodyPadding() {
      let headerHeight = $header.outerHeight() + "px";
      $body.css("padding-top", headerHeight);
      $menu.css("padding-top", headerHeight);
    }
  }

  return {
    init: init,
  };
})();
